export default class ApiUrl {
    //Production
    public static baseUrl: string = "https://api.oneworldnetwork.co/api";
    public static fileBaseUrl: string = "https://api.oneworldnetwork.co/media/";
    public static dashboardBaseUrl: string = "https://login.oneworldnetwork.co/";


    //Chahek Local url
    // public static baseUrl: string = "http://192.168.1.8:8083/api";
    
    // public static fileBaseUrl: string = "http://192.168.1.8:8083/media/";
    // public static dashboardBaseUrl: string = "https://login.oneworldnetwork.net/";

    
    
    

    
    //Rohit Local url
    // public static baseUrl: string = "http://192.168.0.18:8081/api";
    // public static fileBaseUrl: string = "http://192.168.0.18:8081/media/";
    // public static dashboardBaseUrl: string = "https://login.oneworldnetwork.net/";
    

    public static midUrl: string = '/api';

}